export const collapse = ({
  containerSelector = `.js-collapse`,
  buttonSelector = `.js-collapse-btn`,
  contentSelector = `.js-collapse-block`,
  showClass = `show`,
  isOpenIndex,
}) => {
  const collapseContainerElements = document.querySelectorAll(containerSelector);

  const hideContent = (content) => {
    content.style.maxHeight = `0`;
    content.style.visibility = ``;
  };

  const showContent = (content) => {
    content.style.maxHeight = `${content.scrollHeight}px`;
    content.style.visibility = `visible`;
  };

  if (collapseContainerElements.length) {
    collapseContainerElements.forEach((parent) => {
      parent.addEventListener(`click`, (evt) => {
        const target = evt.target;
        const self = evt.currentTarget;

        const control = self.querySelector(buttonSelector);

        if (target === control || target.parentNode === control) {
          const content = self.querySelector(contentSelector);

          self.classList.toggle(showClass);

          if (self.classList.contains(showClass)) {
            showContent(content);
          } else {
            hideContent(content);
          }
        }
      });
    });

    if (typeof isOpenIndex === `number`) {
      collapseContainerElements[isOpenIndex].classList.add(showClass);
      const content = collapseContainerElements[isOpenIndex].querySelector(contentSelector);

      if (collapseContainerElements[isOpenIndex].classList.contains(showClass)) {
        showContent(content);
      } else {
        hideContent(content);
      }
    }
  }
};
